import { graphql, HeadProps, PageProps } from "gatsby";
import React, { useState } from "react";
import Hero, {
  HeaderTitle,
  HighlightTitle,
  SubTitle,
  Magical,
} from "../components/hero/Hero";
import Layout from "../components/layout/Layout";
import GoogleMap from "../components/google-map/GoogleMap";
import Page, {
  PageBody,
  PageGallery,
  PageImage,
  PageVideo,
} from "../components/page/page";
import Places from "../components/blocks/places/places";
import LatestRandom from "../components/blocks/highlight-random/highlight-random";

const LocationTemplate = ({ data }: PageProps<Queries.LocationPageByQuery>) => {

  if (!data.contentfulLocation) return <>Error: No location page</>;
  if (!data.contentfulSiteSettings) return <>Error: No site settings</>;

  const {
    contentful_id,
    coordinates,
    magicalPlace,
    magicalPlacePosition,
    title,
    images,
    description,
    video,
    backendConnection
  } = data.contentfulLocation;

  const [videoFailed, setVideoFailed] = useState(backendConnection?.video ? false : true)

  return (
    <Layout settings={data.contentfulSiteSettings}>
      <Hero onError={() => setVideoFailed(true)} kind={!videoFailed ? 'video' : 'solid'} video={backendConnection?.video}>
        {magicalPlace && magicalPlacePosition && (
          <Magical num={magicalPlacePosition} />
        )}
        <SubTitle>{magicalPlace ? "Magiskplats" : "Plats"}</SubTitle>
        {title !== null && <HeaderTitle>{title}</HeaderTitle>}
        {coordinates?.lat && coordinates.lon && (
          <HighlightTitle>
            {coordinates?.lat?.toString().slice(0, 10)},{" "}
            {coordinates?.lon?.toString().slice(0, 10)}
          </HighlightTitle>
        )}
      </Hero>
      <Page droppedParent={videoFailed}>
        {images != null && videoFailed && <PageImage images={images} />}
        {description?.raw != null && <PageBody>{description}</PageBody>}
        {images != null && (
          <PageGallery images={images} smallTitle="Galleri" bigTitle="" />
        )}
        {video != null && <PageVideo video={video} title="Video" />}
      </Page>

      <div>
        {coordinates && (
          <h2 className="font-header text-3xl md:text-7xl lg:w-3/6 mx-auto mb-10 text-c-places-title uppercase">
            Här finns platsen
          </h2>
        )}
        <GoogleMap
          hideSort
          highlight={{
            id: contentful_id,
            lat: coordinates?.lat ?? null,
            lng: coordinates?.lon ?? null,
          }}
        />
      </div>
      <Places />
      <LatestRandom />
    </Layout>
  );
};

export default LocationTemplate;

export function Head({ data }: HeadProps<Queries.LocationPageByQuery>) {
  return (
    <>
      <html lang="se" />
      <title>
        Somewhere In Sandviken
        {data.contentfulLocation?.title &&
          ` - ${data.contentfulLocation?.title}`}{" "}
      </title>
    </>
  );
}

export const query = graphql`
  query LocationPageBy($slug: String!) {
    contentfulLocation(slug: { eq: $slug }) {
      contentful_id
      __typename
      id
      title
      slug
      magicalPlace
      magicalPlacePosition
      images {
        gatsbyImageData(
          formats: WEBP
          quality: 75
          layout: FULL_WIDTH
          placeholder: BLURRED
        )
        description
        title
      }
      description {
        raw
      }
      video {
        file {
          contentType
          fileName
          url
        }
      }
      coordinates {
        lon
        lat
      }
      backendConnection {
        video {
          src
          type
        }
      }
    }
    contentfulSiteSettings(contentful_id: { eq: "3v4EbPtBo1Oiw3YkPsyEjQ" }) {
      __typename
      ...SiteSettings
    }
  }
`;
